module.exports = __webpack_public_path__ + "img/cb9c7c5.jpg";